function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { checkIsTizenVersion, DeviceType, TizenVersion } from '@sky-uk-ott/client-lib-js-device';
import { PlayerType } from '../core/player/player-type';
import { getLgWebOsVersion } from '../utils/device-type';
export var tizenDefaultPlayerSelectionHandler = function(deviceInfo) {
    if (deviceInfo && (checkIsTizenVersion(deviceInfo, TizenVersion['Tizen-2.4']) || checkIsTizenVersion(deviceInfo, TizenVersion['Tizen-2.3']))) {
        return PlayerType.Theo;
    } else {
        return PlayerType.Shaka;
    }
};
export var webOsDefaultPlayerSelectionHandler = function(deviceInfo) {
    if (deviceInfo && getLgWebOsVersion(deviceInfo) <= 3) {
        return PlayerType.DualPlayer;
    } else {
        return PlayerType.Shaka;
    }
};
export var getDefaultDevicePlayerMap = function(deviceInfo) {
    var _obj;
    return _obj = {}, _define_property(_obj, DeviceType.Generic, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Browser, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Vidaa, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Vizio, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Ion, {
        default: PlayerType.Tape
    }), _define_property(_obj, DeviceType.WebOS, {
        default: webOsDefaultPlayerSelectionHandler(deviceInfo)
    }), _define_property(_obj, DeviceType.Tizen, {
        default: tizenDefaultPlayerSelectionHandler(deviceInfo)
    }), _define_property(_obj, DeviceType.WebMaf, {
        default: PlayerType.WebMaf
    }), _define_property(_obj, DeviceType.Prospero, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.XboxOne, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.XboxSeries, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.WinUI2, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.YouView, {
        default: PlayerType.YouView
    }), _define_property(_obj, DeviceType.Android, {
        default: PlayerType.Android
    }), _define_property(_obj, DeviceType.Chromecast, {
        default: PlayerType.Chromecast
    }), _define_property(_obj, DeviceType.Llama, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Kepler, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Netgem, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Xfinity, {
        default: PlayerType.Aamp
    }), _define_property(_obj, DeviceType.Zenterio, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.OneSdk, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.RDK, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Quest, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.MultiChoiceRdk, {
        default: PlayerType.Shaka
    }), _define_property(_obj, DeviceType.Kpn, {
        default: PlayerType.Shaka
    }), _obj;
};

//# sourceMappingURL=default-device-player-map.js.map